import { createMemoStyles } from '@wds/styles';
var useStyles = createMemoStyles(function (_ref) {
  var shadow = _ref.shadow,
    spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    descriptionBox: {
      whiteSpace: 'normal'
    },
    grow3505Workgroups: {
      border: [1, 'solid', palette.text.dark],
      boxSizing: 'content-box',
      padding: spacing[4],
      borderRadius: 3,
      margin: [spacing[3], 'auto'],
      width: '80%',
      whiteSpace: 'normal',
      '&:hover, &:focus': {
        boxShadow: shadow.space,
        cursor: 'pointer'
      }
    },
    grow3505WorkgroupBlurb: {
      paddingBottom: spacing[2],
      '& > svg': {
        margin: [spacing[1], spacing[3], 0, 0]
      }
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map